import React from "react";
export class Portal extends React.Component {
  static displayName = "Portal";
  constructor(props) {
    super(props);
    this.map = {};
    this.index = 1;
  }
  portalRegister = () => {
    return ++this.index;
  };
  portalUpdate = (key, element) => {
    this.map[key] = element;
    this.forceUpdate();
  };
  portalDeregister = key => {
    delete this.map[key];
    this.forceUpdate();
  };
  getChildren() {
    return Object.keys(this.map).map(key => {
      const el = this.map[key];
      return el ? /*#__PURE__*/React.cloneElement(el, {
        key
      }) : el;
    });
  }

  // Overridden in victory-core-native
  render() {
    return /*#__PURE__*/React.createElement("svg", this.props, this.getChildren());
  }
}